import React from 'react';
import { NumberInput, TextInput } from 'ui-toolkit';
import { createOnChangeHandlerGenerator } from '../utilities/createOnChangeHandlerGenerator';
import IHasItemDataProps from './IHasItemDataProps';
import IHasItemEventProps from './IHasItemEventProps';
import IHasMetaDataModalProps from './IHasMetaDataModalProps';
import IHasMetaDataModalState from './IHasMetaDataModalState';
import IItemProps from './IItemProps';
import ItemMetaDataModal, { IItemMetaDataModalRef } from './ItemMetaDataModal/ItemMetaDataModal';
import SharedItemCells from './SharedItemCells';
import './_NonInterestPrepayment.scss';
import { INonInterestPrepaymentViewItem } from '../../../ui-toolkit/cdItems/interfaces/ICDViewItem';
import { eNonInterestPrepayments } from 'ui-toolkit/enums/eNonInterestPrepayments';
import { isNil } from 'lodash';

const labelForSubType = {
  [eNonInterestPrepayments.homeowners_insurance]: "Homeowner's Insurance Premium",
  [eNonInterestPrepayments.mortgage_insurance]: 'Mortgage Insurance Premium',
  [eNonInterestPrepayments.property_tax]: 'Property Taxes',
};

interface INonInterestPrepaymentProps
  extends IItemProps,
    IHasItemDataProps<INonInterestPrepaymentViewItem>,
    Required<IHasItemEventProps<INonInterestPrepaymentViewItem>>,
    IHasMetaDataModalProps {}

type INonInterestPrepaymentState = IHasMetaDataModalState;

export default class NonInterestPrepayment extends React.Component<
  INonInterestPrepaymentProps,
  INonInterestPrepaymentState
> {
  public state = { expanded: !this.props.disableAutoExpand && this.props.data.new };
  private modal = React.createRef<IItemMetaDataModalRef>();
  private firstInputNode: HTMLInputElement | null = null;

  public render() {
    const { data, onChange, hasEditPermissions } = this.props;

    const generateDefaultOnChangeHandler = createOnChangeHandlerGenerator(data, onChange);
    const payeeOnChange = generateDefaultOnChangeHandler('payee');
    const monthsOnChange = generateDefaultOnChangeHandler('months');
    return (
      <div className="non-interest-prepayment">
        <SharedItemCells {...this.props} readOnly={!hasEditPermissions}>
          <ItemMetaDataModal
            expanded={this.state.expanded}
            expandedLabel={labelForSubType[data.sub_type]}
            label={
              <span>
                {labelForSubType[data.sub_type]} (<strong>{`${isNil(data.months) ? '__' : data.months} mon`}</strong>)
                to&nbsp;
                <strong>{data.payee}</strong>
              </span>
            }
            onToggle={this.onModalToggleEvent}
            ref={this.modal}
          >
            <div className="non-interest-prepayment__extra">
              <div className="non-interest-prepayment__months">
                <NumberInput
                  allowNegative={false}
                  label="No. of months"
                  name="months"
                  getInputRef={this.setFirstInputNode}
                  onBlur={this.onBlurEvent}
                  onChange={monthsOnChange}
                  value={data.months}
                  readOnly={!hasEditPermissions}
                  debounceOnValueChange
                />
              </div>
              <TextInput
                className="non-interest-prepayment__payee"
                label="Payee"
                onBlur={this.onBlurEvent}
                onChange={payeeOnChange}
                placeholder="Payee"
                value={data.payee}
                readOnly={!hasEditPermissions}
                debounceOnValueChange
              />
            </div>
          </ItemMetaDataModal>
        </SharedItemCells>
      </div>
    );
  }

  private onBlurEvent = (event: React.FocusEvent) => {
    const node = this.modal.current;
    if (node && event.relatedTarget && !node.modalContains(event.relatedTarget as HTMLElement)) {
      this.setState({
        expanded: false,
      });
    }
  };

  private onModalToggleEvent = (expanded: boolean) => {
    this.setState({ expanded });
    if (this.firstInputNode) {
      this.firstInputNode.focus();
    }
  };

  private setFirstInputNode = (input: HTMLInputElement | null) => {
    this.firstInputNode = input;
  };
}
